import {NUMBER} from '@drivesally/sally-fw/lib/inputTypes';

// attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

// types
import formattedInteger from '@drivesally/sally-fw/lib/type/types/formattedInteger.type';
import number from '@drivesally/sally-fw/lib/type/types/number.type';

export default attribute({
  type: NUMBER,
  attribute: 'booking_advance_days',
  display: formattedInteger,
  input: formattedInteger,
  api: number,
  label: {
    default: 'Booking Days in Advance',
    short: 'Booking Days in Advance',
  },
});
